import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { TypeAheadMenu } from './TypeAheadMenu';
export function ContentComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    popupMountRef = _ref.popupMountRef;
  var _useSharedPluginState = useSharedPluginState(api, ['typeAhead']),
    typeAheadState = _useSharedPluginState.typeAheadState;
  if (!typeAheadState) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TypeAheadMenu, {
    editorView: editorView,
    popupMountRef: popupMountRef,
    typeAheadState: typeAheadState,
    api: api
  });
}